import { addQueryParamsToUrl } from './use-chart-frame.util';
export function appendExtraDataToUrl(url, data) {
    return addQueryParamsToUrl(url, data);
}
//# sourceMappingURL=extra-data.js.map